import React from 'react';
// import CircularProgress from '@material-ui/core/CircularProgress';
import { Grid } from '@material-ui/core';
import Load from "../assets/small.gif";

function CircularLoading() {

  return (
    <Grid
      container
      spacing={0}
      alignItems="center"
      justify="center"
      style={{ minHeight: '100vh',  backgroundColor: "#fff" }}
    >
     {/* <CircularProgress/>*/}
     <img src={Load} alt="" height="300px" width="300px" />
    </Grid>
  )
}

export default CircularLoading;